import React from "react";

export function Label({ text, children, className, ...rest }) {
  return (
    <label className={className} {...rest}>
      {text} {children}
    </label>
  );
}
